const $ = require('jquery');
const intro = require('../vendor/intro').introJs();
const menu = require('./menu');
const loginPopups = require('./loginPopups');

module.exports = {
  init() {
    if (typeof op_tour_params === 'undefined') {
      return false;
    }

    intro.setOptions({
      showStepNumbers: false,
      nextLabel: op_tour_params.texts.next,
      doneLabel: op_tour_params.texts.done,
      skipLabel: op_tour_params.texts.done,
      tooltipClass: 'tourStep-tooltip',
      steps: op_tour_params.steps,
      exitOnOverlayClick: false,
    });

    $(document).on('click', '.introjs-overlay', (e) => {
      e.preventDefault();
      intro.nextStep();
    });
    $(document).on('click', '.tourStep-tooltip--last .introjs-nextbutton.introjs-disabled', (e) => {
      intro.exit();
    });

    let menu_disabled = false;
    let show_arrow = false;

    let dropMenuMainOpen = false;

    let $slickSlider = null;
    let initialSlickIndex = null;

    let profileOpen =  false;

    intro.onbeforechange((el) => {
      if ($(el).hasClass('tour-settings') || $(el).hasClass('tour-favorites')) {
        $('#header-drop').removeClass('is-hidden');
        $('#header-drop').addClass('dropdown--tour');
        menu.disableDropdown();
        menu_disabled = true;
      } else if (menu_disabled == true) {
        $('#header-drop').removeClass('dropdown--tour');
        menu.enableDropdown();
        menu_disabled = false;
      }

      if ($(el).hasClass('sliderArrow')) {
        $('.sliderArrow').addClass('sliderArrow--visible');
        show_arrow = true;
      } else if (show_arrow == true) {
        $('.sliderArrow').removeClass('sliderArrow--visible');
      }

      if ($(el).hasClass('dropMenuMain-item')) {
        $('#header-drop-main').removeClass('is-hidden');
        $('#header-drop-main').addClass('dropdown--tour');
        dropMenuMainOpen = true;
      } else if (dropMenuMainOpen) {
        $('#header-drop-main').addClass('is-hidden');
        $('#header-drop-main').removeClass('dropdown--tour');
        dropMenuMainOpen = false;
      }

      if ($(el).hasClass('slick-slide')) {
        $slickSlider = $(el).closest('.slick-slider');
        const slickIndex = $(el).data('slick-index');

        $slickSlider.slick('slickGoTo', slickIndex);
        $slickSlider.find('.slick-list').addClass('tour');

        if (initialSlickIndex === null) {
          initialSlickIndex = slickIndex;
        }
      } else if ($slickSlider) {
        $slickSlider.slick('slickGoTo', initialSlickIndex);
        $slickSlider.find('.slick-list').removeClass('tour');
        
        $slickSlider = null;
        initialSlickIndex = null;
      }

      if ($(el).hasClass('leftpanel-tour') && $('.subNav-myProfile').is(':visible') && !profileOpen) {
        $('.subNav-myProfile').click();
        profileOpen = true;
      }
    });

    intro.onafterchange((el) => {
      if ($(el).hasClass('tour-settings') || $(el).hasClass('tour-favorites')) {
        // lai normāli rādītos dropdown
        $('#header-drop').removeClass('introjs-fixParent');
      }

      if ($(el).hasClass('dropMenuMain-item')) {
        // lai normāli rādītos dropdown
        $('#header-drop-main').removeClass('introjs-fixParent');
      }

      if ($(el).hasClass('slick-slide')) {
        $(el).closest('.slick-list').removeClass('introjs-fixParent');
        $(el).closest('.slick-track').removeClass('introjs-fixParent');
      }
    });

    $('.menu-notification').addClass('is-hidden');
    intro.start();

    intro.onexit((el) => {
      $('.menu-notification').removeClass('is-hidden');
      // loginPopups.init();
      $('.dropdown').removeClass('dropdown--tour');
      $('.slick-list').removeClass('tour');
    });
    intro.oncomplete((el) => {
      $('.menu-notification').removeClass('is-hidden');
      // loginPopups.init();
    });

    // TODO kāpēc netiek uzstādīts pareiza bottom vērtība pirmajā reizē
    const tooltip = $('.introjs-tooltip');
    let tooltip_offset_bottom = tooltip.css('bottom').replace(/[^-\d\.]/g, '');
    tooltip_offset_bottom -= 15;
    tooltip.css({ bottom: `${tooltip_offset_bottom}px` });

    return true;
  },
};
